export default {"src":"/_next/static/media/mail-closed.487a5bcf.svg","height":30,"width":42,"blurWidth":0,"blurHeight":0};